<template>
    <templatesite>
        <template v-slot:appheader><appheader></appheader></template>
        <template v-slot:appsidebar><appsidebar></appsidebar></template>
        <template v-slot:appcontent>

            <!-- Start::menu -->
            <appmenu></appmenu>
            <!-- end::menu -->

            <div class="content" style="margin-top: 0">
                <div class="main-content">

                    <!-- En-tête de page + actions -->
                    <div class="ds-page-head">
                        <div>
                            <h1 class="ds-page-head__title">
                                <i class="ri-dashboard-3-line"></i> Tableau de bord du stock
                            </h1>
                            <p class="ds-page-head__sub">Dernière mise à jour : {{ lastUpdateTime }}</p>
                        </div>
                        <div class="cf-tool-grp">
                            <button @click="lancerCorrectionStock" type="button"
                                    class="ti-btn ti-btn-success-full !font-medium !text-[0.8rem]"
                                    :disabled="correctionEnCours">
                                <i class="ri-tools-fill"></i>
                                {{ correctionEnCours ? 'Correction en cours...' : 'Lancer Correction' }}
                            </button>
                            <button @click="init" type="button"
                                    class="ti-btn ti-btn-primary-full !font-medium !text-[0.8rem]">
                                <i class="ri-refresh-fill"></i> Actualiser
                            </button>
                        </div>
                    </div>

                    <!-- KPIs principaux -->
                    <div class="tb-kpi-grid">
                        <div class="tb-kpi tb-kpi--danger">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-alert-fill"></i></span>
                                <span class="tb-kpi__tag">CRITIQUE</span>
                            </div>
                            <p class="tb-kpi__label">Articles critiques</p>
                            <h3 class="tb-kpi__value">{{ kpis.articlesCritiques }}</h3>
                            <p class="tb-kpi__hint"><i class="ri-arrow-down-line"></i> Stock minimum atteint</p>
                        </div>

                        <div class="tb-kpi tb-kpi--warn">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-error-warning-fill"></i></span>
                                <span class="tb-kpi__tag">ALERTE</span>
                            </div>
                            <p class="tb-kpi__label">Stocks négatifs</p>
                            <h3 class="tb-kpi__value">{{ kpis.stocksNegatifs }}</h3>
                            <p class="tb-kpi__hint"><i class="ri-tools-line"></i> À corriger immédiatement</p>
                        </div>

                        <div class="tb-kpi tb-kpi--info">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-file-list-3-fill"></i></span>
                                <span class="tb-kpi__tag">AUJOURD'HUI</span>
                            </div>
                            <p class="tb-kpi__label">Mouvements</p>
                            <h3 class="tb-kpi__value">{{ kpis.mouvementsDuJour }}</h3>
                            <p class="tb-kpi__hint"><i class="ri-calendar-check-line"></i> Documents créés</p>
                        </div>

                        <div class="tb-kpi tb-kpi--violet">
                            <div class="tb-kpi__top">
                                <span class="tb-kpi__icon"><i class="ri-inbox-unarchive-fill"></i></span>
                                <span class="tb-kpi__tag">EN ATTENTE</span>
                            </div>
                            <p class="tb-kpi__label">Articles non traités</p>
                            <h3 class="tb-kpi__value">{{ kpis.articlesNonTraites }}</h3>
                            <p class="tb-kpi__hint"><i class="ri-time-line"></i> En attente de correction</p>
                        </div>
                    </div>

                    <!-- KPIs secondaires -->
                    <div class="tb-mini-grid">
                        <div class="tb-mini">
                            <span class="tb-mini__icon"><i class="ri-building-2-fill"></i></span>
                            <p class="tb-mini__label">Entrepôts</p>
                            <h4 class="tb-mini__value">{{ kpis.entrepotsActifs }}</h4>
                        </div>
                        <div class="tb-mini">
                            <span class="tb-mini__icon"><i class="ri-refresh-line"></i></span>
                            <p class="tb-mini__label">Rotation</p>
                            <h4 class="tb-mini__value">{{ kpis.tauxRotation }}<span class="tb-mini__unit">%</span></h4>
                        </div>
                        <div class="tb-mini">
                            <span class="tb-mini__icon"><i class="ri-history-fill"></i></span>
                            <p class="tb-mini__label">Dernier traitement</p>
                            <h4 class="tb-mini__value tb-mini__value--sm">{{ kpis.dernierTraitement }}</h4>
                        </div>
                        <div class="tb-mini">
                            <span class="tb-mini__icon"><i class="ri-tools-fill"></i></span>
                            <p class="tb-mini__label">Corrections/mois</p>
                            <h4 class="tb-mini__value">{{ kpis.correctionsMois }}</h4>
                        </div>
                        <div class="tb-mini">
                            <span class="tb-mini__icon"><i class="ri-checkbox-circle-fill"></i></span>
                            <p class="tb-mini__label">Précision</p>
                            <h4 class="tb-mini__value">{{ kpis.precisionStock }}<span class="tb-mini__unit">%</span></h4>
                        </div>
                        <div class="tb-mini">
                            <span class="tb-mini__icon"><i class="ri-archive-fill"></i></span>
                            <p class="tb-mini__label">Articles actifs</p>
                            <h4 class="tb-mini__value">{{ kpis.totalArticles || 0 }}</h4>
                        </div>
                    </div>

                    <!-- Fiche technique : matières premières en alerte (masqué s'il n'y en a aucune) -->
                    <alertesmatieres></alertesmatieres>

                    <!-- Onglets + contenu -->
                    <div class="cf-card cf-card--flush">
                        <div class="cf-tabs">
                            <button class="cf-tab" :class="{ 'cf-tab--on': activeTab === 'alertes' }"
                                    @click="activeTab = 'alertes'">
                                <i class="ri-alert-fill"></i>
                                <span class="hidden md:inline">Alertes</span>
                                <span class="cf-pill">{{ kpis.articlesCritiques }}</span>
                            </button>
                            <button class="cf-tab" :class="{ 'cf-tab--on': activeTab === 'mouvements' }"
                                    @click="activeTab = 'mouvements'">
                                <i class="ri-file-list-3-fill"></i>
                                <span class="hidden md:inline">Mouvements</span>
                                <span class="cf-pill">{{ kpis.mouvementsDuJour }}</span>
                            </button>
                            <button class="cf-tab" :class="{ 'cf-tab--on': activeTab === 'traitements' }"
                                    @click="activeTab = 'traitements'">
                                <i class="ri-history-fill"></i>
                                <span class="hidden md:inline">Historique</span>
                            </button>
                            <button class="cf-tab" :class="{ 'cf-tab--on': activeTab === 'negatifs' }"
                                    @click="activeTab = 'negatifs'">
                                <i class="ri-error-warning-fill"></i>
                                <span class="hidden md:inline">Négatifs</span>
                                <span class="cf-pill">{{ kpis.stocksNegatifs }}</span>
                            </button>
                        </div>

                        <!-- TAB 1: Alertes stocks -->
                        <div v-show="activeTab === 'alertes'" class="tb-panel">
                            <div class="tb-panel-head">
                                <div class="tb-panel-title">
                                    <i class="ri-alert-fill cf-danger"></i>
                                    Articles en stock minimum
                                    <span class="cf-chip cf-chip--ko">{{ datatablestockminimum.length }}</span>
                                </div>
                                <button @click="apercuavantimpression('Articles en stock minimum', 'exportable_table')"
                                        class="ti-btn ti-btn-primary !text-[0.78rem]">
                                    <i class="ri-printer-fill"></i> Imprimer
                                </button>
                            </div>

                            <div class="cf-toolbar tb-toolbar">
                                <div class="search-wrap">
                                    <i class="ri-search-line search-icon"></i>
                                    <input v-model="searchwordstockminimum" class="search-input" type="text"
                                           placeholder="Rechercher un article...">
                                </div>
                                <div class="cf-select-wrap">
                                    <select v-model="filterEntrepotAlertes" class="cf-select--sm">
                                        <option value="">Tous les entrepôts</option>
                                        <option v-for="mag in listeEntrepots" :key="mag.id" :value="mag.id">
                                            {{ mag.nommaga }}
                                        </option>
                                    </select>
                                    <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                </div>
                            </div>

                            <div class="table-scroll-wrap tb-scroll">
                                <table ref="exportable_table" class="doc-table">
                                    <thead>
                                    <tr>
                                        <th class="th">ENTREPÔT</th>
                                        <th class="th">ARTICLE</th>
                                        <th class="th th--center">STOCK</th>
                                        <th class="th th--center">MIN</th>
                                        <th class="th th--center">ÉCART</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-if="loadingtablestockminimum">
                                        <template v-if="filteredAlertes.length">
                                            <tr class="table-row" v-for="(datavalue, index) in filteredAlertes" :key="index">
                                                <td class="td">{{ datavalue.nommaga }}</td>
                                                <td class="td">
                                                    <p class="cf-strong">{{ datavalue.libelle }}</p>
                                                    <p class="cf-ellip">{{ datavalue.ref }}</p>
                                                </td>
                                                <td class="td td--center">
                                                    <span :class="getStockClass(datavalue.stock)" class="px-3 py-1 rounded-full text-xs font-semibold">
                                                        {{ datavalue.stock }}
                                                    </span>
                                                </td>
                                                <td class="td td--center">{{ datavalue.stock_min || 0 }}</td>
                                                <td class="td td--center">
                                                    <span :class="datavalue.stock < (datavalue.stock_min || 0) ? 'cf-danger' : 'cf-faint'">
                                                        {{ datavalue.stock - (datavalue.stock_min || 0) }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="5">
                                                    <div class="empty-state">
                                                        <i class="ri-checkbox-circle-fill empty-state__icon cf-ok"></i>
                                                        <p class="empty-state__title">Aucun article en alerte !</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="5">
                                                <div class="animate-pulse space-y-4 p-4">
                                                    <div class="h-4 bg-gray-200 rounded"></div>
                                                    <div class="h-4 bg-gray-300 rounded"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- TAB 2: Mouvements du jour -->
                        <div v-show="activeTab === 'mouvements'" class="tb-panel">
                            <div class="tb-panel-head">
                                <div class="tb-panel-title">
                                    <i class="ri-file-list-3-fill" style="color:#2563eb"></i>
                                    Mouvements du {{ $store.state.appserverdate }}
                                    <span class="cf-chip cf-chip--info">{{ datatabledocday.length }}</span>
                                </div>
                                <div class="cf-select-wrap">
                                    <select v-model="filterTypeDoc" class="cf-select--sm">
                                        <option value="">Tous les types</option>
                                        <option value="MI">Inventaire</option>
                                        <option value="ME">Entrée</option>
                                        <option value="MS">Sortie</option>
                                        <option value="MT">Transfert</option>
                                        <option value="F">Facture</option>
                                    </select>
                                    <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                                </div>
                            </div>

                            <div class="table-scroll-wrap tb-scroll">
                                <table class="doc-table">
                                    <thead>
                                    <tr>
                                        <th class="th th--center">ACTION</th>
                                        <th class="th">N° DOC</th>
                                        <th class="th">TYPE</th>
                                        <th class="th">ENTREPÔT</th>
                                        <th class="th">SAISIE PAR</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-if="loadingtablestockdocstock">
                                        <template v-if="filteredMouvements.length">
                                            <tr class="table-row" v-for="(datavalue, index) in filteredMouvements" :key="index">
                                                <td class="td td--center">
                                                    <button @click="btnopen(datavalue)" class="cf-iconbtn cf-iconbtn--primary" title="Ouvrir">
                                                        <i class="ri-folder-open-fill"></i>
                                                    </button>
                                                </td>
                                                <td class="td"><span class="cf-docnum">{{ datavalue.numdoc }}</span></td>
                                                <td class="td">
                                                    <span class="px-2 py-1 rounded-full text-xs font-semibold" :class="getTypeDocClass(datavalue.typedoc)">
                                                        {{ getTypeDocLabel(datavalue.typedoc) }}
                                                    </span>
                                                </td>
                                                <td class="td">{{ datavalue.magname }}</td>
                                                <td class="td">{{ datavalue.saisiepar }}</td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="5">
                                                    <div class="empty-state">
                                                        <i class="ri-information-fill empty-state__icon" style="color:#2563eb"></i>
                                                        <p class="empty-state__title">Aucun mouvement aujourd'hui</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="5">
                                                <div class="animate-pulse space-y-4 p-4">
                                                    <div class="h-4 bg-gray-200 rounded"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- TAB 3: Historique -->
                        <div v-show="activeTab === 'traitements'" class="tb-panel">
                            <div class="tb-panel-head">
                                <div class="tb-panel-title">
                                    <i class="ri-history-fill" style="color:#7c3aed"></i>
                                    Historique des corrections
                                    <span class="cf-chip">{{ filteredHistorique.length }} / {{ dataTraitements.length }}</span>
                                </div>
                                <button @click="resetFiltresHistorique" class="ti-btn ti-btn-secondary !text-[0.78rem]">
                                    <i class="ri-refresh-line"></i> Réinitialiser
                                </button>
                            </div>

                            <!-- Filtres -->
                            <div class="cf-toolbar tb-toolbar tb-filters">
                                <div class="cf-field tb-f-date">
                                    <span>Date début</span>
                                    <input type="date" v-model="filterDateDebut" class="form-control form-control-sm cf-input-sm">
                                </div>
                                <div class="cf-field tb-f-date">
                                    <span>Date fin</span>
                                    <input type="date" v-model="filterDateFin" class="form-control form-control-sm cf-input-sm">
                                </div>
                                <div class="cf-field tb-f-lim">
                                    <span>Limite serveur</span>
                                    <select v-model.number="filterLimitHistorique" class="form-control form-control-sm cf-input-sm">
                                        <option v-for="limit in limitOptions" :key="limit" :value="limit">{{ limit }} max</option>
                                    </select>
                                </div>
                                <div class="cf-field tb-f-lim">
                                    <span>Par page</span>
                                    <select v-model.number="perPageHistorique" class="form-control form-control-sm cf-input-sm">
                                        <option :value="10">10</option>
                                        <option :value="20">20</option>
                                        <option :value="50">50</option>
                                        <option :value="100">100</option>
                                        <option :value="200">200</option>
                                    </select>
                                </div>
                                <div class="cf-field tb-f-btn">
                                    <span>&nbsp;</span>
                                    <button @click="chargerTraitements" class="ti-btn ti-btn-primary !text-[0.78rem] w-full">
                                        <i class="ri-search-line"></i> Charger
                                    </button>
                                </div>
                                <div class="cf-field tb-f-wide">
                                    <span>Rechercher un article</span>
                                    <input v-model="filterArticleHistorique" class="form-control form-control-sm cf-input-sm"
                                           type="text" placeholder="Nom ou référence de l'article..." @input="pageHistorique = 1">
                                </div>
                                <div class="cf-field tb-f-wide">
                                    <span>Filtrer par entrepôt</span>
                                    <select v-model="filterEntrepotHistorique" class="form-control form-control-sm cf-input-sm" @change="pageHistorique = 1">
                                        <option value="">Tous les entrepôts</option>
                                        <option v-for="mag in listeEntrepotsHistorique" :key="mag.dbmagkey" :value="mag.dbmagkey">
                                            {{ mag.nom }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Tableau -->
                            <div class="table-scroll-wrap tb-scroll">
                                <table class="doc-table">
                                    <thead>
                                    <tr>
                                        <th class="th th--center">N°</th>
                                        <th class="th th--triable" @click="sortTableHistorique('date_execution')">
                                            DATE <i :class="getSortIconHistorique('date_execution')" class="cf-tri"></i>
                                        </th>
                                        <th class="th th--triable" @click="sortTableHistorique('article_libelle')">
                                            ARTICLE <i :class="getSortIconHistorique('article_libelle')" class="cf-tri"></i>
                                        </th>
                                        <th class="th th--triable" @click="sortTableHistorique('entrepot_nom')">
                                            ENTREPÔT <i :class="getSortIconHistorique('entrepot_nom')" class="cf-tri"></i>
                                        </th>
                                        <th class="th th--center th--triable" @click="sortTableHistorique('dbstcksstckqte')">
                                            Stock DB <i :class="getSortIconHistorique('dbstcksstckqte')" class="cf-tri"></i>
                                        </th>
                                        <th class="th th--center th--triable" @click="sortTableHistorique('stock_avant_correction')">
                                            AVANT <i :class="getSortIconHistorique('stock_avant_correction')" class="cf-tri"></i>
                                        </th>
                                        <th class="th th--center th--triable" @click="sortTableHistorique('stock_apres_correction')">
                                            APRÈS <i :class="getSortIconHistorique('stock_apres_correction')" class="cf-tri"></i>
                                        </th>
                                        <th class="th th--center">ÉCART</th>
                                        <th class="th th--center">ÉCART DB</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-if="loadingTraitements">
                                        <template v-if="paginatedHistorique.length">
                                            <tr class="table-row" v-for="(trait, index) in paginatedHistorique" :key="trait.id || index">
                                                <td class="td td--center row-number">
                                                    {{ (pageHistorique - 1) * perPageHistorique + index + 1 }}
                                                </td>
                                                <td class="td" style="font-size:0.76rem">{{ formatDateTime(trait.date_execution) }}</td>
                                                <td class="td">
                                                    <p class="cf-strong">{{ trait.article_libelle }}</p>
                                                    <p class="cf-ellip">{{ trait.article_ref }}</p>
                                                </td>
                                                <td class="td">{{ trait.entrepot_nom }}</td>
                                                <td class="td td--center"><span class="cf-badge cf-badge--muted">{{ trait.dbstcksstckqte }}</span></td>
                                                <td class="td td--center"><span class="px-2 py-1 bg-blue-50 text-blue-800 rounded text-xs font-semibold">{{ trait.stock_avant_correction }}</span></td>
                                                <td class="td td--center">
                                                    <span class="px-2 py-1 rounded text-xs font-semibold"
                                                          :class="trait.stock_apres_correction < 0 ? 'bg-red-100 text-red-800' : 'bg-green-50 text-green-800'">
                                                        {{ trait.stock_apres_correction }}
                                                    </span>
                                                </td>
                                                <td class="td td--center">
                                                    <span :class="getEcartClass(trait.stock_apres_correction - trait.stock_avant_correction)" class="font-semibold text-sm">
                                                        {{ formatEcart(trait.stock_apres_correction - trait.stock_avant_correction) }}
                                                    </span>
                                                </td>
                                                <td class="td td--center">
                                                    <span :class="getEcartClass(trait.stock_apres_correction - trait.dbstcksstckqte)" class="font-semibold text-sm">
                                                        {{ formatEcart(trait.stock_apres_correction - trait.dbstcksstckqte) }}
                                                    </span>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="9">
                                                    <div class="empty-state">
                                                        <i class="ri-information-fill empty-state__icon" style="color:#2563eb"></i>
                                                        <p class="empty-state__title">Aucun traitement trouvé avec ces filtres</p>
                                                        <button @click="resetFiltresHistorique" class="ti-btn ti-btn-primary !text-[0.78rem] mt-3">
                                                            <i class="ri-refresh-line"></i> Réinitialiser les filtres
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="9">
                                                <div class="animate-pulse space-y-4 p-4">
                                                    <div class="h-4 bg-gray-200 rounded"></div>
                                                    <div class="h-4 bg-gray-300 rounded"></div>
                                                    <div class="h-4 bg-gray-200 rounded"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Pagination -->
                            <div class="cf-dialog-foot cf-dialog-foot--split tb-foot">
                                <p class="cf-foot-info">
                                    Affichage de <b>{{ (pageHistorique - 1) * perPageHistorique + 1 }}</b>
                                    à <b>{{ Math.min(pageHistorique * perPageHistorique, filteredHistorique.length) }}</b>
                                    sur <b>{{ filteredHistorique.length }}</b> résultats
                                    <span v-if="filteredHistorique.length < dataTraitements.length" class="cf-faint">
                                        ({{ dataTraitements.length }} au total)
                                    </span>
                                </p>
                                <div class="pagination">
                                    <button @click="pageHistorique = 1" :disabled="pageHistorique === 1" class="page-btn page-btn--nav">
                                        <i class="ri-skip-back-fill"></i>
                                    </button>
                                    <button @click="pageHistorique--" :disabled="pageHistorique === 1" class="page-btn page-btn--nav">
                                        <i class="ri-arrow-left-s-line"></i>
                                    </button>
                                    <div class="tb-page-jump">
                                        <span>Page</span>
                                        <input type="number" v-model.number="pageHistorique" :min="1" :max="totalPagesHistorique"
                                               class="form-control form-control-sm cf-input-sm" style="width:3.5rem;text-align:center"
                                               @input="pageHistorique = Math.max(1, Math.min(totalPagesHistorique, pageHistorique))">
                                        <span>sur {{ totalPagesHistorique }}</span>
                                    </div>
                                    <button @click="pageHistorique++" :disabled="pageHistorique === totalPagesHistorique" class="page-btn page-btn--nav">
                                        <i class="ri-arrow-right-s-line"></i>
                                    </button>
                                    <button @click="pageHistorique = totalPagesHistorique" :disabled="pageHistorique === totalPagesHistorique" class="page-btn page-btn--nav">
                                        <i class="ri-skip-forward-fill"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- TAB 4: Stocks négatifs -->
                        <div v-show="activeTab === 'negatifs'" class="tb-panel">
                            <div class="tb-panel-head">
                                <div class="tb-panel-title">
                                    <i class="ri-error-warning-fill" style="color:#ea580c"></i>
                                    Stocks négatifs
                                    <span class="cf-chip cf-chip--warn">{{ dataStocksNegatifs.length }}</span>
                                </div>
                            </div>

                            <div class="table-scroll-wrap tb-scroll">
                                <table class="doc-table">
                                    <thead>
                                    <tr>
                                        <th class="th">ARTICLE</th>
                                        <th class="th">ENTREPÔT</th>
                                        <th class="th th--center">STOCK</th>
                                        <th class="th">MAJ</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-if="loadingStocksNegatifs">
                                        <template v-if="dataStocksNegatifs.length">
                                            <tr class="table-row" v-for="(stock, index) in dataStocksNegatifs" :key="index">
                                                <td class="td cf-strong">{{ stock.article_libelle }}</td>
                                                <td class="td">{{ stock.entrepot_nom }}</td>
                                                <td class="td td--center">
                                                    <span class="px-3 py-1 bg-red-100 text-red-800 rounded-full text-xs font-bold">{{ stock.stock_reel }}</span>
                                                </td>
                                                <td class="td">{{ formatDateTime(stock.date_maj) }}</td>
                                            </tr>
                                        </template>
                                        <template v-else>
                                            <tr>
                                                <td colspan="4">
                                                    <div class="empty-state">
                                                        <i class="ri-checkbox-circle-fill empty-state__icon cf-ok"></i>
                                                        <p class="empty-state__title">Aucun stock négatif !</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="4">
                                                <div class="animate-pulse space-y-4 p-4">
                                                    <div class="h-4 bg-gray-200 rounded"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </template>
    </templatesite>

    <!-- Modals -->
    <modalopenform ref="modalopenform"></modalopenform>
    <modalprintdefault ref="modalprintdefault"></modalprintdefault>
</template>

<script>
    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/stock/menu";
    import * as JwtService from "@/common/jwt.service";
    import { currentDateTime, randomString } from "@/allfunction";
    import modalopenform from "@/components/views/pages/stock/mvtstock/modal_openform";
    import modalprintdefault from "@/components/views/pages/modal_printdefault";
    import alertesmatieres from "@/components/views/pages/stock/fichetechnique/alertesmatieres";
    const axios = require('axios');

    export default {
        /* eslint-disable */
        name: "dashboard-stock",
        components: {
            templatesite,
            appheader,
            appsidebar,
            appmenu,
            modalopenform,
            modalprintdefault,
            alertesmatieres,
        },
        data() {
            return {
                activeTab: 'alertes',
                datatablestockminimum: [],
                datatabledocday: [],
                dataTraitements: [],
                dataStocksNegatifs: [],
                listeEntrepots: [],
                loadingtablestockminimum: false,
                loadingtablestockdocstock: false,
                loadingTraitements: false,
                loadingStocksNegatifs: false,
                correctionEnCours: false,
                searchwordstockminimum: "",
                filterEntrepotAlertes: "",
                filterTypeDoc: "",
                filterDateDebut: "",
                filterDateFin: "",
                kpis: {
                    articlesCritiques: 0,
                    stocksNegatifs: 0,
                    mouvementsDuJour: 0,
                    articlesNonTraites: 0,
                    entrepotsActifs: 0,
                    tauxRotation: 0,
                    dernierTraitement: '-',
                    correctionsMois: 0,
                    precisionStock: 0,
                    totalArticles: 0,
                },
                lastUpdateTime: '',

                // ✅ NOUVELLES VARIABLES POUR L'HISTORIQUE
                filterArticleHistorique: "",
                filterEntrepotHistorique: "",
                filterLimitHistorique: 3000,
                pageHistorique: 1,
                perPageHistorique: 20,
                sortColumnHistorique: 'date_execution',
                sortDirectionHistorique: 'desc',
                limitOptions: [100, 500, 1000, 3000, 5000],
            };
        },

        computed: {
            filteredAlertes() {
                let data = this.datatablestockminimum;
                if (this.searchwordstockminimum) {
                    data = data.filter(item =>
                        item.libelle?.toLowerCase().includes(this.searchwordstockminimum.toLowerCase()) ||
                        item.nommaga?.toLowerCase().includes(this.searchwordstockminimum.toLowerCase())
                    );
                }
                if (this.filterEntrepotAlertes) {
                    data = data.filter(item => item.dbmagkey === this.filterEntrepotAlertes);
                }
                return data;
            },

            filteredMouvements() {
                let data = this.datatabledocday;
                if (this.filterTypeDoc) {
                    data = data.filter(item => item.typedoc === this.filterTypeDoc);
                }
                return data;
            },

            // ✅ NOUVEAUX COMPUTED POUR L'HISTORIQUE
            filteredHistorique() {
                let data = [...this.dataTraitements];

                if (this.filterArticleHistorique) {
                    data = data.filter(item =>
                        item.article_libelle?.toLowerCase().includes(this.filterArticleHistorique.toLowerCase()) ||
                        item.article_ref?.toLowerCase().includes(this.filterArticleHistorique.toLowerCase())
                    );
                }

                if (this.filterEntrepotHistorique) {
                    data = data.filter(item => item.dbmagkey === this.filterEntrepotHistorique);
                }

                if (this.sortColumnHistorique) {
                    data.sort((a, b) => {
                        let valA = a[this.sortColumnHistorique];
                        let valB = b[this.sortColumnHistorique];

                        if (valA === null || valA === undefined) valA = '';
                        if (valB === null || valB === undefined) valB = '';

                        if (['stock_avant_correction', 'stock_apres_correction', 'dbstcksstckqte'].includes(this.sortColumnHistorique)) {
                            valA = parseFloat(valA) || 0;
                            valB = parseFloat(valB) || 0;
                        }

                        if (this.sortDirectionHistorique === 'asc') {
                            return valA > valB ? 1 : -1;
                        } else {
                            return valA < valB ? 1 : -1;
                        }
                    });
                }

                return data;
            },

            paginatedHistorique() {
                const start = (this.pageHistorique - 1) * this.perPageHistorique;
                const end = start + this.perPageHistorique;
                return this.filteredHistorique.slice(start, end);
            },

            totalPagesHistorique() {
                return Math.ceil(this.filteredHistorique.length / this.perPageHistorique);
            },

            listeEntrepotsHistorique() {
                const entrepots = new Map();
                this.dataTraitements.forEach(item => {
                    if (item.entrepot_nom && item.dbmagkey) {
                        entrepots.set(item.dbmagkey, item.entrepot_nom);
                    }
                });
                return Array.from(entrepots, ([dbmagkey, nom]) => ({ dbmagkey, nom }));
            },
        },

        methods: {
            async init() {
                this.lastUpdateTime = new Date().toLocaleString('fr-FR');
                await Promise.all([
                    this.inittableaustock(),
                    this.inittableauelistedocday(),
                    this.chargerKPIs(),
                    this.chargerTraitements(),
                    this.chargerStocksNegatifs(),
                ]);
            },

            async inittableaustock() {
                const t = this;
                t.loadingtablestockminimum = false;

                const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874ar771714dfe/stock/tb/alerte/${this.$store.state.appsociete}/${randomString()}`;

                try {
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        t.datatablestockminimum = response.data.m || [];
                        t.kpis.articlesCritiques = response.data.m?.length || 0;
                    }
                    t.loadingtablestockminimum = true;
                } catch (error) {
                    console.error("Erreur inittableaustock:", error);
                    t.loadingtablestockminimum = true;
                    toastr['error']("Erreur chargement alertes", "");
                }
            },

            async inittableauelistedocday() {
                const t = this;
                t.loadingtablestockdocstock = false;

                const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/day/${this.$store.state.appserverdate}/${this.$store.state.appserverdate}/${this.$store.state.appsociete}/${randomString()}`;

                try {
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        t.datatabledocday = response.data.m || [];
                        t.kpis.mouvementsDuJour = response.data.m?.length || 0;
                    }
                    t.loadingtablestockdocstock = true;
                } catch (error) {
                    console.error("Erreur inittableauelistedocday:", error);
                    t.loadingtablestockdocstock = true;
                    toastr['error']("Erreur chargement mouvements", "");
                }
            },

            async lancerCorrectionStock() {
                if (!confirm('Confirmez-vous le lancement de la correction de stock ?\n\n⚠️ ATTENTION : Cette opération ne peut pas être annulée.')) {
                    return;
                }

                this.correctionEnCours = true;
                toastr['info']("Correction en cours...", "");

                const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874ar771714dfe/stock/correctionstock/${this.$store.state.appsociete}/${randomString()}`;

                try {
                    const response = await axios.post(url, {}, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        toastr['success'](`Correction terminée ! ${response.data.articlesTraites || 0} articles`, "");
                        await this.init();
                    } else {
                        toastr['error'](response.data.message || "Erreur correction", "");
                    }
                } catch (error) {
                    console.error("Erreur lancerCorrectionStock:", error);
                    toastr['error']("Erreur lors de la correction", "");
                } finally {
                    this.correctionEnCours = false;
                }
            },

            async chargerKPIs() {
                const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874ar771714dfe/stock/kpis/${this.$store.state.appsociete}/${randomString()}`;

                try {
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        Object.assign(this.kpis, response.data.kpis);
                    }
                } catch (error) {
                    console.error("Erreur chargerKPIs:", error);
                }
            },

            async chargerTraitements() {
                this.loadingTraitements = false;

                const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874ar771714dfe/stock/traitements/${this.$store.state.appsociete}/${randomString()}`;

                try {
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        params: {
                            date_debut: this.filterDateDebut || null,
                            date_fin: this.filterDateFin || null,
                            limit: this.filterLimitHistorique
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.dataTraitements = response.data.data || [];
                        this.pageHistorique = 1;
                    }
                    this.loadingTraitements = true;
                } catch (error) {
                    console.error("Erreur chargerTraitements:", error);
                    this.loadingTraitements = true;
                }
            },

            async chargerStocksNegatifs() {
                this.loadingStocksNegatifs = false;

                const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874ar771714dfe/stock/negatifs/${this.$store.state.appsociete}/${randomString()}`;

                try {
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        this.dataStocksNegatifs = response.data.data || [];
                        this.kpis.stocksNegatifs = response.data.data?.length || 0;
                    }
                    this.loadingStocksNegatifs = true;
                } catch (error) {
                    console.error("Erreur chargerStocksNegatifs:", error);
                    this.loadingStocksNegatifs = true;
                }
            },

            // ✅ NOUVELLES MÉTHODES POUR L'HISTORIQUE
            sortTableHistorique(column) {
                if (this.sortColumnHistorique === column) {
                    this.sortDirectionHistorique = this.sortDirectionHistorique === 'asc' ? 'desc' : 'asc';
                } else {
                    this.sortColumnHistorique = column;
                    this.sortDirectionHistorique = 'desc';
                }
            },

            getSortIconHistorique(column) {
                if (this.sortColumnHistorique !== column) {
                    return 'ri-arrow-up-down-line text-gray-400';
                }
                return this.sortDirectionHistorique === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line';
            },

            resetFiltresHistorique() {
                this.filterDateDebut = "";
                this.filterDateFin = "";
                this.filterArticleHistorique = "";
                this.filterEntrepotHistorique = "";
                this.filterLimitHistorique = 3000;
                this.pageHistorique = 1;
                this.chargerTraitements();
            },

            btnopen(value) {
                const titlemodal = "Document " + value.numdoc;
                this.$refs.modalopenform.showupdate(titlemodal, "update", this.typedoc, value, this.otherdata);
            },

            formatDateTime(date) {
                if (!date) return '-';
                return new Date(date).toLocaleString('fr-FR');
            },

            formatEcart(ecart) {
                return ecart > 0 ? `+${ecart}` : ecart;
            },

            getStockClass(stock) {
                if (stock <= 0) return 'bg-red-100 text-red-800';
                if (stock <= 10) return 'bg-orange-100 text-orange-800';
                return 'bg-green-100 text-green-800';
            },

            getEcartClass(ecart) {
                if (ecart > 0) return 'text-green-600 font-semibold';
                if (ecart < 0) return 'text-red-600 font-semibold';
                return 'text-gray-600';
            },

            getTypeDocClass(type) {
                const classes = {
                    'MI': 'bg-purple-100 text-purple-800',
                    'ME': 'bg-green-100 text-green-800',
                    'MS': 'bg-orange-100 text-orange-800',
                    'MT': 'bg-blue-100 text-blue-800',
                    'F': 'bg-red-100 text-red-800',
                };
                return classes[type] || 'bg-gray-100 text-gray-800';
            },

            getTypeDocLabel(type) {
                const labels = {
                    'MI': 'Inventaire',
                    'ME': 'Entrée',
                    'MS': 'Sortie',
                    'MT': 'Transfert',
                    'F': 'Facture',
                };
                return labels[type] || type;
            },

            apercuavantimpression(valuetitre, tableref) {
                const $tableref = this.$refs[tableref];
                const tabvalue = {
                    titres: valuetitre,
                    numdoc: '',
                    date: currentDateTime(),
                    datedebut: "-",
                    datefin: "-",
                    total1: 0,
                    total2: 0,
                    total3: 0,
                    total4: 0,
                    tableref: $tableref.toString(),
                };
                this.$refs.modalprintdefault.show(tabvalue, $tableref);
            },
        },

        mounted() {
            this.init();

            // Actualisation automatique toutes les 5 minutes
            setInterval(() => {
                this.init();
            }, 5 * 60 * 1000);
        }
    };
</script>

<style scoped>
    /* Charte cf-/ds- : tokens uniquement (light-only) */

    /* KPIs principaux */
    .tb-kpi-grid {
        display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1rem; margin-bottom: 1rem;
    }
    @media (min-width: 1024px) { .tb-kpi-grid { grid-template-columns: repeat(4, minmax(0, 1fr)); } }
    .tb-kpi {
        position: relative; overflow: hidden; background: #fff;
        border: 1px solid var(--cf-border); border-left: 4px solid var(--cf-border);
        border-radius: var(--cf-radius); padding: 1rem 1.1rem;
        box-shadow: var(--cf-shadow-sm); transition: box-shadow 0.2s ease, transform 0.2s ease;
    }
    .tb-kpi:hover { box-shadow: var(--cf-shadow-md); transform: translateY(-2px); }
    .tb-kpi__top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.6rem; }
    .tb-kpi__icon {
        height: 44px; width: 44px; border-radius: var(--cf-radius-sm);
        display: inline-flex; align-items: center; justify-content: center; font-size: 1.4rem;
    }
    .tb-kpi__tag { font-size: 0.64rem; font-weight: 700; padding: 3px 10px; border-radius: 999px; letter-spacing: 0.03em; }
    .tb-kpi__label { font-size: 0.8rem; font-weight: 500; color: var(--cf-muted); margin: 0 0 0.15rem; }
    .tb-kpi__value { font-size: 2.1rem; font-weight: 800; color: var(--cf-ink-strong); margin: 0; line-height: 1.1; font-variant-numeric: tabular-nums; }
    .tb-kpi__hint { display: flex; align-items: center; gap: 0.25rem; font-size: 0.72rem; color: var(--cf-faint); margin: 0.5rem 0 0; }

    .tb-kpi--danger { border-left-color: #ef4444; }
    .tb-kpi--danger .tb-kpi__icon { background: #fee2e2; color: #dc2626; }
    .tb-kpi--danger .tb-kpi__tag  { background: #fef2f2; color: #dc2626; }
    .tb-kpi--warn { border-left-color: #f97316; }
    .tb-kpi--warn .tb-kpi__icon { background: #ffedd5; color: #ea580c; }
    .tb-kpi--warn .tb-kpi__tag  { background: #fff7ed; color: #ea580c; }
    .tb-kpi--info { border-left-color: #3b82f6; }
    .tb-kpi--info .tb-kpi__icon { background: #dbeafe; color: #2563eb; }
    .tb-kpi--info .tb-kpi__tag  { background: #eff6ff; color: #2563eb; }
    .tb-kpi--violet { border-left-color: #8b5cf6; }
    .tb-kpi--violet .tb-kpi__icon { background: #ede9fe; color: #7c3aed; }
    .tb-kpi--violet .tb-kpi__tag  { background: #f5f3ff; color: #7c3aed; }

    /* KPIs secondaires */
    .tb-mini-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0.75rem; margin-bottom: 1.25rem; }
    @media (min-width: 768px) { .tb-mini-grid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
    @media (min-width: 1024px) { .tb-mini-grid { grid-template-columns: repeat(6, minmax(0, 1fr)); } }
    .tb-mini {
        background: #fff; border: 1px solid var(--cf-border); border-radius: var(--cf-radius-sm);
        padding: 0.75rem 0.85rem; box-shadow: var(--cf-shadow-sm); transition: box-shadow 0.2s ease;
    }
    .tb-mini:hover { box-shadow: var(--cf-shadow-md); }
    .tb-mini__icon {
        height: 32px; width: 32px; border-radius: var(--cf-radius-sm);
        display: inline-flex; align-items: center; justify-content: center; font-size: 1rem;
        background: rgb(var(--primary) / 0.10); color: rgb(var(--primary)); margin-bottom: 0.4rem;
    }
    .tb-mini__label { font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--cf-muted); margin: 0 0 0.15rem; }
    .tb-mini__value { font-size: 1.4rem; font-weight: 800; color: var(--cf-ink-strong); margin: 0; font-variant-numeric: tabular-nums; }
    .tb-mini__value--sm { font-size: 0.85rem; }
    .tb-mini__unit { font-size: 0.8rem; font-weight: 600; color: var(--cf-muted); }

    /* Bloc onglets */
    .cf-card--flush { padding: 0; overflow: hidden; }
    .cf-tabs {
        display: flex; gap: 0.25rem; flex-wrap: wrap;
        padding: 0.6rem 1rem 0; background: var(--cf-surface); border-bottom: 1px solid var(--cf-border);
    }
    .cf-tab {
        display: inline-flex; align-items: center; gap: 0.4rem;
        font-size: 0.82rem; font-weight: 600; padding: 0.55rem 1rem;
        border-radius: var(--cf-radius-sm) var(--cf-radius-sm) 0 0;
        color: var(--cf-muted); background: transparent; border: 1px solid transparent; cursor: pointer;
        transition: color 0.18s ease, background-color 0.18s ease;
    }
    .cf-tab:hover { color: rgb(var(--primary)); }
    .cf-tab--on { background: #fff; border-color: var(--cf-border); border-bottom-color: #fff; color: rgb(var(--primary)); margin-bottom: -1px; }
    .cf-pill { font-size: 0.66rem; font-weight: 700; background: var(--cf-surface-alt); color: var(--cf-muted); padding: 1px 8px; border-radius: 999px; }

    /* Panneau d'onglet */
    .tb-panel { padding: 1rem 1.1rem 0; }
    .tb-panel-head { display: flex; align-items: center; justify-content: space-between; gap: 0.75rem; flex-wrap: wrap; margin-bottom: 0.9rem; }
    .tb-panel-title { display: flex; align-items: center; gap: 0.5rem; font-size: 0.9rem; font-weight: 700; color: var(--cf-ink-strong); }
    .tb-toolbar { margin-bottom: 0.9rem; }

    /* Chips (compteurs) */
    .cf-chip { display: inline-flex; align-items: center; font-size: 0.72rem; font-weight: 600; padding: 0.15rem 0.6rem; border-radius: 999px; border: 1px solid var(--cf-border); background: #fff; color: var(--cf-ink); }
    .cf-chip--ko   { border-color: #fecaca; background: #fef2f2; color: #b91c1c; }
    .cf-chip--info { border-color: #bfdbfe; background: #eff6ff; color: #1d4ed8; }
    .cf-chip--warn { border-color: #fde68a; background: #fffbeb; color: #a16207; }

    /* Recherche */
    .search-wrap { position: relative; flex: 1; min-width: 180px; }
    .search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--cf-faint); }
    .search-input { width: 100%; padding: 9px 12px 9px 34px; border: 1px solid rgb(var(--input-border,203 213 225)); border-radius: var(--cf-radius-sm); font-size: 0.82rem; color: var(--cf-ink); outline: none; transition: border-color 0.2s; }
    .search-input:focus { border-color: rgb(var(--primary)); box-shadow: 0 0 0 3px rgb(var(--primary) / 0.10); }

    /* Selects */
    .cf-select-wrap { position: relative; }
    .cf-select--sm { appearance: none; height: 38px; padding: 0 30px 0 12px; border: 1px solid rgb(var(--input-border,203 213 225)); border-radius: var(--cf-radius-sm); background: #fff; font-size: 0.82rem; color: var(--cf-ink); cursor: pointer; }
    .cf-select-arrow { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); color: var(--cf-faint); pointer-events: none; }

    /* Filtres historique */
    .tb-filters { align-items: flex-end; }
    .tb-filters .cf-field { flex: 1 1 8rem; }
    .tb-filters .cf-field > span { font-size: 0.68rem; text-transform: uppercase; letter-spacing: 0.03em; color: var(--cf-muted); font-weight: 600; margin-bottom: 0.2rem; }
    .tb-f-wide { flex: 1 1 100% !important; }
    @media (min-width: 1024px) { .tb-f-wide { flex: 1 1 45% !important; } }

    /* Table */
    .table-scroll-wrap { overflow: auto; }
    .tb-scroll { max-height: 420px; }
    .doc-table { width: 100%; text-align: left; border-collapse: collapse; min-width: 640px; }
    .th { position: sticky; top: 0; z-index: 2; padding: 0.7rem 1rem; font-weight: 600; font-size: 0.72rem; color: var(--cf-ink); background: var(--cf-surface-alt); border-bottom: 1px solid var(--cf-border); white-space: nowrap; letter-spacing: 0.02em; text-align: left; text-transform: uppercase; }
    .th--center { text-align: center; }
    .th--triable { cursor: pointer; user-select: none; }
    .th--triable:hover { background: #e2e8f0; }
    .cf-tri { margin-left: 0.25rem; font-size: 0.78rem; }
    .table-row { border-bottom: 1px solid var(--cf-surface-alt); transition: background-color 0.15s; }
    .table-row:hover { background: var(--cf-surface); }
    .td { padding: 0.6rem 1rem; font-size: 0.82rem; color: var(--cf-ink); vertical-align: middle; }
    .td--center { text-align: center; }
    .row-number { color: var(--cf-faint); font-size: 0.75rem; font-variant-numeric: tabular-nums; }
    .cf-strong { font-weight: 600; color: var(--cf-ink-strong); font-size: 0.82rem; margin: 0; }
    .cf-ellip { display: inline-block; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; vertical-align: middle; color: var(--cf-faint); font-size: 0.72rem; margin: 0; }
    .cf-docnum { display: inline-flex; align-items: center; padding: 2px 9px; font-size: 0.78rem; font-weight: 600; color: rgb(var(--primary)); background: rgb(var(--primary) / 0.10); border-radius: var(--cf-radius-sm); font-family: ui-monospace, monospace; }
    .cf-danger { color: #dc2626; font-weight: 700; }
    .cf-ok { color: #16a34a; }
    .cf-faint { color: var(--cf-faint); }

    /* Boutons icônes */
    .cf-iconbtn { height: 2rem; width: 2rem; display: inline-flex; align-items: center; justify-content: center; border: none; border-radius: var(--cf-radius-sm); cursor: pointer; font-size: 1rem; transition: all 0.15s; background: var(--cf-surface-alt); color: var(--cf-muted); }
    .cf-iconbtn--primary:hover { background: rgb(var(--primary) / 0.12); color: rgb(var(--primary)); }

    /* Badges */
    .cf-badge { display: inline-flex; align-items: center; padding: 2px 9px; font-size: 0.72rem; font-weight: 600; border-radius: 999px; white-space: nowrap; }
    .cf-badge--muted { background: var(--cf-surface-alt); color: var(--cf-muted); }

    /* État vide */
    .empty-state { padding: 2.5rem 1.5rem; text-align: center; }
    .empty-state__icon { font-size: 40px; margin-bottom: 14px; display: block; }
    .empty-state__title { font-size: 0.95rem; font-weight: 600; color: var(--cf-ink-strong); margin: 0; }

    /* Pied / pagination */
    .cf-dialog-foot { display: flex; align-items: center; justify-content: flex-end; gap: 0.6rem; padding: 0.9rem 1.1rem; border-top: 1px solid var(--cf-border); background: var(--cf-surface); }
    .cf-dialog-foot--split { justify-content: space-between; flex-wrap: wrap; gap: 0.6rem; }
    .tb-foot { margin: 1rem -1.1rem 0; }
    .cf-foot-info { font-size: 0.78rem; color: var(--cf-muted); margin: 0; }
    .cf-foot-info b { color: rgb(var(--primary)); }
    .pagination { display: flex; align-items: center; gap: 4px; flex-wrap: wrap; }
    .page-btn { min-width: 30px; height: 30px; padding: 0 8px; border: 1px solid rgb(var(--input-border,203 213 225)); border-radius: var(--cf-radius-sm); background: #fff; color: var(--cf-ink); font-size: 0.78rem; font-weight: 600; cursor: pointer; transition: all 0.15s; }
    .page-btn:hover:not(:disabled) { border-color: rgb(var(--primary) / 0.35); background: var(--cf-surface); }
    .page-btn:disabled { opacity: 0.5; cursor: not-allowed; }
    .page-btn--nav { width: 34px; display: inline-flex; align-items: center; justify-content: center; }
    .tb-page-jump { display: flex; align-items: center; gap: 0.4rem; background: #fff; padding: 3px 10px; border: 1px solid var(--cf-border); border-radius: var(--cf-radius-sm); font-size: 0.78rem; color: var(--cf-muted); }

    .tb-scroll::-webkit-scrollbar { width: 8px; height: 8px; }
    .tb-scroll::-webkit-scrollbar-track { background: #f1f5f9; border-radius: 10px; }
    .tb-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 10px; }
    .tb-scroll::-webkit-scrollbar-thumb:hover { background: #94a3b8; }

    @media (max-width: 768px) {
        .tb-scroll { max-height: 320px; }
        .tb-kpi__value { font-size: 1.7rem; }
    }
</style>
